import store from "../store/index.js";

export class BaseApiService {
    //baseUrl = "BASEURL/";
    baseUrl = process.env.VUE_APP_BACKEND_BASE_URL;
    // token = 'TOKEN';
    route_map = {};
    config =  {
        // Authorization: `Bearer ${this.token}`
    };

    constructor(route_map) {
      if (!route_map) throw new Error("Route map is not provided");
      this.route_map = route_map;
    }
  
    getUrl(route_name, id = "", string = "") {
        // if( !this.route_map[route_name] ) throw new Error(`Route ${route_name} not fount`);
        if( this.route_map[route_name] == 'undefined'  ) throw new Error(`Route ${route_name} not fount`);
        let url_part = this.route_map[route_name];

        if( id != "" )
            url_part = url_part.replace("{id}", id)

        url_part = url_part.replace('{string}', string);
    
        // console.log("arg", `${this.baseUrl}/${url_part}`);
        
        return `${this.baseUrl}/${url_part}`;
    }
  
    async server_fetch(route_name, id = "", string = "", config = {}) {

        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", 'Bearer ' + store.getters.token);
        // myHeaders.append("Content-Type", "application/json");

        if(string != 'upload')
            myHeaders.append("Content-Type", "application/json");

        config.headers = myHeaders


        try {
            /* if(string == "upload"){
                console.log("this.getUrl(route_name, id, string)",this.getUrl(route_name, id, string));
                console.log("try,config",config);
                console.log("try,config body 1 - type",config.body.get('type'));
                console.log("try,config body 1 - file1",config.body.get('file'));
                console.log("try,config body 2 - file2",config.body.get('file1'));
                console.log("try,config H - Accept",config.headers.get('Accept'));
                console.log("try,config H - Authorization",config.headers.get('Authorization'));
                console.log("try,config H - Content-Type",config.headers.get('Content-Type'));
            } */
            
            const response = await fetch(this.getUrl(route_name, id, string), config);

            if(await response.url.includes("export"))
                return await response;

            return await response.json();

        } catch (err) {
            this.handleErrors(err);
        }
    }

    handleErrors(err) {
        // Note: here you may want to add your errors handling
        console.log({ message: "Errors is handled here", err });
    }

}